import { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { SERVICES } from "../data";
import { t } from "../i18n";
import { fadeUp, stagger } from "../motion";

export default function ServiceDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const svc = SERVICES.find((s) => s.slug === slug);

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!svc) {
    return (
      <main className="pt-40 pb-24 text-center min-h-screen">
        <p className="text-slate-600">Leistung nicht gefunden.</p>
        <button onClick={() => nav("/")} className="mt-4 text-gold-600">Zurück zur Startseite</button>
      </main>
    );
  }

  const Icon = svc.icon;

  return (
    <main data-testid="service-detail" className="min-h-screen bg-white">
      <section className="relative pt-40 pb-24 bg-navy-900 overflow-hidden grain">
        <div className="absolute inset-0 opacity-30">
          <img src={svc.image} alt={svc.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/80 to-navy-900/60" />
        </div>
        <div className="container mx-auto px-6 md:px-12 max-w-7xl relative">
          <Link to="/#services" data-testid="back-link" className="inline-flex items-center gap-2 text-white/70 hover:text-gold-400 transition-colors mb-8">
            <ArrowLeft size={18} /> {t.de.nav.services}
          </Link>
          <motion.div variants={stagger} initial="hidden" animate="show" className="max-w-3xl">
            <motion.div variants={fadeUp} className="w-16 h-16 rounded-2xl bg-gold-500 flex items-center justify-center mb-6">
              <Icon size={32} weight="light" className="text-white" />
            </motion.div>
            <motion.h1 variants={fadeUp} className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white">{svc.title}</motion.h1>
            <motion.p variants={fadeUp} className="mt-5 text-lg md:text-xl text-white/70 leading-relaxed">{svc.short}</motion.p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-lg text-slate-600 leading-relaxed">{svc.long}</p>
            <div className="mt-10 space-y-4">
              {svc.points.map((p) => (
                <div key={p} className="flex items-center gap-3">
                  <CheckCircle size={24} weight="light" className="text-gold-500 shrink-0" />
                  <span className="text-navy-900 font-medium">{p}</span>
                </div>
              ))}
            </div>
            <Link
              to="/kontakt"
              className="group mt-10 inline-flex items-center gap-2 bg-navy-900 text-white rounded-full px-8 py-4 font-medium transition-all hover:bg-gold-500 hover:-translate-y-0.5"
            >
              {t.de.hero.cta1} <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="relative rounded-3xl overflow-hidden aspect-[4/3]">
            <img src={svc.image} alt={svc.title} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </main>
  );
}
